import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./styles.scss";

const HelpPage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t("AtVitae - Help page");
  }, [t]);

  return (
    <>
      <p className="help-page-p">
        {t("Please send an email to")}{" "}
        <a href="mailto:dt.support@moongy.pt">dt.support@moongy.pt</a>
      </p>
    </>
  );
};

export default HelpPage;
